import api from '@/services/api/config';

const path = 'v1/assets-infrastruktur/historie/typ';

export default {
  get: () => api.get(path),
};
